import clsx from 'clsx'

interface UiAlertMessageProps {
  variant?: 'error' | 'success' | 'info'
  message?: string
}

export function UiAlertMessage({
  variant = 'error',
  message = 'Error loading prompts. Please try again.',
}: UiAlertMessageProps) {
  return (
    <div className="tc-mv-main-wrapper pb-8">
      <div className="h-full mt-0 pt-[88px]">
        <div className="text-white tc-mv-card-wrapper">
          <div className="flex justify-center items-center min-h-[calc(100vh-210px)]">
            <div
              className={clsx({
                'text-red-400': variant === 'error',
                'text-green-400': variant === 'success',
                'text-grey-400': variant === 'info',
              })}
            >
              {message}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
